import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";
import SalesArrow from "../../../Artifacts/sales per.svg";
import SalesArrow1 from "../../../Artifacts/dse.svg";

// 🔹 API function
const dseApi = async (body) => {
  try {
    const res = await axInst.post("dealer-review/dse_metric", body);
    return res.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

// 🔹 Gauge chart option generator
// const getGaugeOption = (label, value, count, color) => ({
//   series: [
//     {
//       type: "gauge",
//       startAngle: 90,
//       endAngle: -270,
//       radius: "100%",
//       progress: {
//         show: true,
//         width: 6,
//         itemStyle: { color },
//       },
//       axisLine: {
//         lineStyle: {
//           width: 6,
//           color: [[1, "#e5e7eb"]],
//         },
//       },
//       axisTick: { show: false },
//       splitLine: { show: false },
//       axisLabel: { show: false },
//       pointer: { show: false },
//       detail: {
//         valueAnimation: true,
//         fontSize: 10,
//         fontWeight: "bold",
//         color: "#fff",
//         // round value to 2 digits
//         formatter: (v) => v?.toFixed(2) + "%",
//         offsetCenter: ["0%", "0%"], // center of circle
//       },
//       data: [{ value: value || 0 }],
//     },
//   ],
// });

export const DseMatrics = () => {
  const { data, submitted } = useSelector((e) => e.filtersDealerReview);

  const {
    data: dseData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["dseData", submitted],
    queryFn: () => dseApi(data),
    cacheTime: 0,
    staleTime: 0,
  });

  const item = dseData?.[0];
  const metrics = [
    { key: "B1", color: "#bdd7ee" },
    { key: "G1", color: "#abcf8f" },
    { key: "R1", color: "#f4af85" },
    { key: "B2", color: "#ffff67" },
  ];

  return (
    <div className="bg-white rounded-md p-2 pt-1 pb-1 shadow-lg relative h-full">
      {/* Header */}
      <div className=" text-lg font-bold text-gray-800 pl-2">
        DSE Talent Grid
      </div>

      {/* Loader */}
      {isFetching && (
        <div className="flex items-center justify-center h-[200px]">
          <Loader />
        </div>
      )}

      {/* Error */}
      {isError && (
        <div className="flex items-center justify-center h-[200px]">
          <p>Error Occurred: {isError.message}</p>
        </div>
      )}

      {/* No Data */}
      {!isFetching && !dseData?.length && (
        <div className="flex items-center justify-center h-[200px]">
          <p>Data not available</p>
        </div>
      )}

      {!isFetching && dseData?.length > 0 && (
        <div className="flex justify-center ">
          {/* Vertical labels */}

          <div className="w-[10%] ">
            <div className="flex items-center justify-center ">
              <img src={SalesArrow1} alt="Arrow 2" className="h-[147px]" />
            </div>
          </div>

          <div className="">
            <div className="grid  grid-cols-2 mb-1">
              {metrics.map(({ key, color }) => (
                <div
                  key={key}
                  className="flex flex-col shadow pl-1 pt-0 pr-0  h-[74px] w-[90px]"
                  style={{ backgroundColor: color, borderRadius: 0 }}
                >
                  {/* Top row: key (left) and G1++ placeholder (right) */}
                  <div className="flex justify-between items-center h-[27px]">
                    <span
                      className={`font-bold text-black text-sm ${
                        key === "B2" ? "text-right w-full p-1" : ""
                      }`}
                    >
                      {key}
                    </span>

                    {/* Show G1++ space only if not B2 */}
                    {key !== "B2" && (
                      <div className="text-[9px] font-bold text-center w-[34px]">
                        {key === "G1" && item?.["G1++"] ? (
                          <div className="bg-[#40e366] text-black">
                            G1++
                            <span className="block">
                              {item["G1++"]?.per ?? 0}%
                            </span>
                          </div>
                        ) : null}
                      </div>
                    )}
                  </div>

                  {/* Count and percentage in center */}
                  <div className="flex flex-col items-center justify-center flex-1">
                    <p className="text-gray-800 text-sm">
                      {item[key]?.count ?? 0}
                    </p>
                    <p className="text-gray-800 font-semibold">
                      {item[key]?.per ?? 0}%
                    </p>
                  </div>
                </div>
              ))}
            </div>
            {/* <div className="flex justify-center mt-1">
              <img src={SalesArrow} alt="Description" className="w-full" />
            </div> */}
            <div className="relative flex justify-center mt-1">
              <img
                src={SalesArrow}
                alt="Sales Performance"
                className="w-full"
              />

              {/* Overlay text */}
              <span className="absolute text-white  whitespace-nowrap text-[9px] font-[500] top-1/2 left-[48%] -translate-x-1/2 -translate-y-1/2">
                Sales Performance - {item?.["month"]}
              </span>
            </div>
          </div>
        </div>
      )}

      <WaterMark />
    </div>
  );
};
